<mat-progress-bar mode='indeterminate' color='accent' *ngIf='busy'></mat-progress-bar>

<div fxLayout='column' fxLayoutAlign='start stretch' style='position:relative'>
  <div fxLayout='row wrap' fxLayoutAlign='center center' fxLayoutGap='20px' style='padding:15px'>
    <mat-form-field>
      <mat-label>State</mat-label>
      <mat-select [(ngModel)]='state' placeholder="State">
        <mat-option value='AZ'>AZ</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field>
      <mat-label>First Name (optional)</mat-label>
      <input matInput [(ngModel)]="firstName" placeholder="First Name (optional)">
    </mat-form-field>
    <mat-form-field>
      <mat-label>Last Name</mat-label>
      <input matInput [(ngModel)]="lastName" placeholder="Last Name">
    </mat-form-field>
    <button mat-raised-button color='accent' (click)='performSearch()'>Search</button>
  </div>

  <div *ngIf='!showSearchResults && ! showPlayerInfo' fxLayout='column' fxLayoutAlign='space-around center' style='height: 70vh'>
    <div style='text-align: center'>
      <mat-icon style='font-size: 42px;margin-left:-20px'>
        mood_bad
      </mat-icon>
      <p style='margin-top:-10px'>Nothing Here...</p>
    </div>
  </div>

  <div *ngIf='showSearchResults' style='padding:30px'>
    <div fxLayout='row' fxLayoutAlign='space-between center' class='player-table' style='font-weight: 800'>
      <div fxFlex='25'>
        First Name
      </div>
      <div fxFlex='25'>
        Last Name
      </div>
      <div fxFlex='20'>
        Index
      </div>
      <div fxFlex='15'>
        Handicap Id
      </div>
      <div fxFlex='15'>
        Actions
      </div>
    </div>
    <div *ngFor='let player of playerList' fxLayout='row' fxLayoutAlign='space-between center' class='player-list-item'>
      <div fxFlex='25'>
        {{ player.first }}
      </div>
      <div fxFlex='25'>
        {{ player.last }}
      </div>
      <div fxFlex='20'>
        {{ player.handicap }}
      </div>
      <div fxFlex='15'>
        {{ player.usga_id }}
      </div>
      <div fxFlex='15'>
        <mat-icon matTooltip='Show Player Info' (click)='displayPlayerInfo(player)'>
          list_alt
        </mat-icon>
      </div>
    </div>
  </div>

  <div *ngIf='showPlayerInfo'>
    <s18-handicap-rounds [player]='playerInfo' [canPost]='false'></s18-handicap-rounds>
  </div>
</div>